import { MAX_QUANTITY_LIMIT } from "../../../../../modules/EcommContent/ContactLensesEcommContent/constants.js";
const getMaxSelectableQuantity = ({
  availableQuantity,
  maxOrderableQuantity,
  allowBackOrder
}) => {
  if (!allowBackOrder) {
    if (availableQuantity && availableQuantity < 0) {
      return 0;
    }
    if (maxOrderableQuantity && availableQuantity) {
      return maxOrderableQuantity > availableQuantity ? availableQuantity : maxOrderableQuantity;
    }
    if (availableQuantity !== void 0) {
      return availableQuantity;
    }
  }
  if (maxOrderableQuantity) {
    return maxOrderableQuantity;
  }
  return MAX_QUANTITY_LIMIT;
};
export {
  getMaxSelectableQuantity
};
//# sourceMappingURL=get-max-selectable-quantity.js.map
